import _typeof from "@babel/runtime/helpers/typeof";
import * as Sentry from '@sentry/browser';
var NODE_ENV_PRODUCTION = 'PRODUCTION';
export var FALLBACK_SENTRY_DSN = 'https://fa3b01c3beb54ad1a03f3378d3dc4a54@o19467.ingest.sentry.io/48330';
var validateEnvironment = function validateEnvironment(nodeEnv) {
  return nodeEnv.toUpperCase() === NODE_ENV_PRODUCTION;
};
var informAboutBrowserErrorTrackingStatus = function informAboutBrowserErrorTrackingStatus(nodeEnv) {
  // eslint-disable-next-line no-console
  console.info(['@paddl/utils-js/initialiseBrowserErrorTracking', "Browser error tracking will not be included in bundle when NODE_ENV is set to: ".concat(_typeof(nodeEnv), " ").concat(nodeEnv.toUpperCase(), "."), "Please set NODE_ENV to ".concat(NODE_ENV_PRODUCTION, " to enable browser error tracking.")].join('\n'));
};
export var initialiseBrowserErrorTracking = function initialiseBrowserErrorTracking(_ref) {
  var applicationName = _ref.applicationName,
    sentryDsn = _ref.sentryDsn,
    nodeEnv = _ref.nodeEnv;
  if (validateEnvironment(nodeEnv)) {
    Sentry.init({
      dsn: sentryDsn || FALLBACK_SENTRY_DSN
    });
    Sentry.setContext('application', {
      name: applicationName
    });
  } else {
    informAboutBrowserErrorTrackingStatus(nodeEnv);
  }
};